var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_3394)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 39,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFAC30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6544 109.966L118.017 83.603C119.121 82.4999 120.617 81.8801 122.177 81.8801C123.737 81.8801 125.233 82.4999 126.336 83.603V83.603C126.883 84.1491 127.318 84.7976 127.614 85.5115C127.91 86.2254 128.063 86.9907 128.063 87.7637C128.064 88.5367 127.912 89.3022 127.616 90.0164C127.321 90.7306 126.887 91.3796 126.341 91.9262L104.137 114.13C103.034 115.233 101.538 115.853 99.9776 115.853C98.4175 115.853 96.9213 115.233 95.8181 114.13L91.6544 109.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.087 91.9344L81.9128 114.138C80.8087 115.242 79.3115 115.862 77.7504 115.862C76.1893 115.862 74.6921 115.242 73.5879 114.138L62.2412 102.791C61.1325 101.691 60.5062 100.196 60.5 98.6343C60.4939 97.0725 61.1084 95.5722 62.2084 94.4635C63.3084 93.3548 64.8037 92.7285 66.3655 92.7223C67.9273 92.7162 69.4276 93.3307 70.5363 94.4307L75.4631 99.3575L75.8632 99.7517L77.7504 101.645L79.8227 99.5725L95.7797 83.6095C96.9017 82.6015 98.3677 82.0625 99.8755 82.1036C101.383 82.1448 102.818 82.7629 103.883 83.8306C104.948 84.8983 105.563 86.3341 105.601 87.8419C105.639 89.3497 105.097 90.8146 104.087 91.9344V91.9344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8226 99.5725L77.7503 101.645L75.8632 99.7517C76.4264 100.221 77.145 100.463 77.8776 100.43C78.6103 100.397 79.304 100.091 79.8226 99.5725V99.5725Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_3394",
    x: 0,
    y: 0,
    width: 180,
    height: 180,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0 0.101961 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_3394"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_3394",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b023d39ea2b57e82fe4dab376f2dda2c.svg";
export { ForwardRef as ReactComponent };